export const css = {
    root: '_3Jzk_plN',
    copyright: '_272JGGrB',
    selector: '_47PjTKpU',
    privacypolicy: '_2lbYeHRD',
    disclaimer: '_1kMRvtTa',
    alt: '_26QPnlCr',
    alt_img: '_1ut9e7FU',
    alt_disclaimer: '_1vfqNhH6',
    ' _key': 'afcpe-theme/afcpe/micro/lcc-app/footer'
};
export default css;
